import { render } from "./Speaker.vue?vue&type=template&id=613a043f&lang=pug"
import script from "./Speaker.vue?vue&type=script&lang=js"
export * from "./Speaker.vue?vue&type=script&lang=js"

import "./Speaker.vue?vue&type=style&index=0&id=613a043f&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__